var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"10602c94725ec96213d6360811e09c08f084df19"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yogobe-web@yogobe"]={id:"10602c94725ec96213d6360811e09c08f084df19"};
      